import Form from "../../Helpers/Form/Form";
import { Offcanvas } from "react-bootstrap";
import FormHeader from "../../Helpers/Form/FormParts/FormHeader";
import trans, { isRTL } from "../../../utils";
import RequestFormBody from "./RequestFormBody";
import {
	useCreateRequestMutation,
	useEditRequestMutation,
	useGetSpecificRequestQuery,
} from "../../../Redux/service/Requests/Request";
import { Formik, Form as FormFormik } from "formik";
import Button from "../../Helpers/Button/Button";
import * as Yup from "yup";
import { useContext, useEffect } from "react";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";

export default function FormRequest({
	requestForm,
	setRequestForm,
	isEditing,
}) {
	const { setEdited } = useContext(popupcontext);
	const { refetch, data: editData } = useGetSpecificRequestQuery(requestForm, {
		skip: !isEditing || !requestForm,
	});
	const [createRequest] = useCreateRequestMutation();
	const [editRequest] = useEditRequestMutation();

	useEffect(() => {
		if (isEditing && requestForm) {
			refetch();
		}
	}, [isEditing]);

	let initialValues = {};
	if (isEditing && editData?.data) {
		const data = editData?.data;
		initialValues = {
			description: data?.description || "",
			serviceType: data?.serviceType || "",
			preferredTime: data?.preferredTime || "",
		};
	} else {
		initialValues = {
			description: "",
			serviceType: "",
			preferredTime: "",
		};
	}

	const validationSchema = Yup.object({
		description: Yup.string()
			.required(trans("Request description is required"))
			.matches(/^[^\s]/, trans("cannot start with a space"))
			.min(10, trans("Request description cannot minimum 10 characters"))
			.max(256, trans("Request description cannot exceed 265 characters")),
		serviceType: Yup.string().required(trans("Request type is required")),
		preferredTime: Yup.date()
			.typeError("Preferred time must be a valid date")
			.required("Preferred time is required"),
	});

	const handleFormSubmit = async (values, setSubmitting, resetForm) => {
		setSubmitting(true);

		const payload = {
			...values,
		};

		try {
			if (!isEditing && requestForm) {
				await createRequest(payload).unwrap();
				toast.success(trans("Request created successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			} else {
				await editRequest({
					id: requestForm,
					payload: payload,
				}).unwrap();
				toast.success(trans("Request edited successfully"), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}

			resetForm();
			setRequestForm(false);
			setEdited(true);
		} catch (err) {
			let errorMsg = trans(err?.data?.message ?? "Something went wrong");
			toast.error(errorMsg, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<>
			<Form show={requestForm}>
				<Offcanvas.Header>
					<FormHeader
						title={
							!isEditing ? trans("Add new request") : trans("Edit Requset")
						}
						other={false}
						onClose={() => setRequestForm(false)}
					/>
				</Offcanvas.Header>
				<Offcanvas.Body>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={(values, { setSubmitting, resetForm }) =>
							handleFormSubmit(values, setSubmitting, resetForm)
						}
						validationSchema={validationSchema}
					>
						{({ handleSubmit, isSubmitting }) => (
							<FormFormik onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
								<RequestFormBody isEditing={isEditing} editData={editData} />
								<div className="offcanvas-footer m-0">
									<div className="offcanvas-footer-body gap-8">
										<Button
											type={"primary"}
											htmlType="submit"
											loading={isSubmitting}
											disabled={isSubmitting}
										>
											{isSubmitting ? trans("Saving...") : trans("Save")}
										</Button>
										<Button
											type={"default"}
											htmlType="button"
											disabled={isSubmitting}
											onClick={() => setRequestForm(false)}
										>
											{trans("Cancel")}
										</Button>
									</div>
								</div>
							</FormFormik>
						)}
					</Formik>
				</Offcanvas.Body>
			</Form>
		</>
	);
}
